import {Component, OnInit} from '@angular/core';
import {IonApp, IonRouterOutlet} from '@ionic/angular/standalone';
import {register} from 'swiper/element/bundle';
import {Storage} from "@ionic/storage-angular";
import {StorageService} from "./shared/services/storage/storage.service";
register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [
    IonApp,
    IonRouterOutlet
  ],
  providers: [
    Storage,
    StorageService
  ]
})
export class AppComponent implements OnInit {
  constructor(private storage: Storage) {}

  async ngOnInit() {
    // Initialize storage when app starts
    await this.storage.create();
    console.log('App component initialized storage successfully');
  }
}
